import { render, staticRenderFns } from "./ponchado.vue?vue&type=template&id=12d35493&scoped=true"
import script from "./ponchado.vue?vue&type=script&lang=js"
export * from "./ponchado.vue?vue&type=script&lang=js"
import style0 from "./ponchado.vue?vue&type=style&index=0&id=12d35493&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d35493",
  null
  
)

export default component.exports